import { Theme } from "../../constants";

export default {
    freeDrawContainer: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "20px"
    },
    canvasBtnDiv: {
        display: "flex",
        flexDirection: "row",
        gap: "20px"
    },
    signatureBorder: { 
        border: '1px solid' 
    }
}